import styled, { css } from 'styled-components'
import { LARGE_LAYOUT_THRESHOLD } from '~/core/constants'

export const primaryInfoCss = css`
  ${({ theme }) => ({ ...theme._neo.body02 })}

  @media (max-width: ${LARGE_LAYOUT_THRESHOLD}px) {
    line-height: 24px;
  }
`

export const PrimaryInfo = styled.span`
  ${primaryInfoCss}
`

export const secondaryInfoCss = css`
  ${({ theme }) => ({ ...theme._neo.label01 })}
  color: ${({ theme }) => theme.colorSecondary};

  @media (max-width: ${LARGE_LAYOUT_THRESHOLD}px) {
    font-size: ${({ theme }) => theme._neo.body01.fontSize};
    line-height: 24px;
  }
`

export const SecondaryInfo = styled.span`
  ${secondaryInfoCss}
`

export const label01Css = css`
  ${({ theme }) => ({ ...theme._neo.label01 })}
`

export const Label01 = styled.span`
  ${label01Css}
`

export const labelBold01Css = css`
  ${label01Css}
  font-weight: 600;
`

export const LabelBold01 = styled.span`
  ${labelBold01Css}
`

export const body01Css = css`
  ${({ theme }) => ({ ...theme._neo.body01 })}
`

export const Body01 = styled.span`
  ${body01Css}
`
const body02Css = css`
  ${({ theme }) => ({ ...theme._neo.body02 })}
`

export const Body02 = styled.span`
  ${body02Css}
`

export const BodyBold01 = styled(Body01)`
  font-weight: 600;
`

export const BodyBold02 = styled(Body02)`
  font-weight: 600;
`

export const ProdHeading01 = styled.span`
  ${({ theme }) => ({ ...theme._neo.heading01 })}
  color: ${({ theme }) => theme.colorTertiary};
`

export const Heading2 = styled.h2`
  ${({ theme }) => ({ ...theme._neo.bodyBold02 })}
`
export const Heading3 = styled.h3`
  ${({ theme }) => ({ ...theme._neo.bodyBold01 })}
`
export const Heading4 = styled.h4`
  ${({ theme }) => ({ ...theme._neo.bodyBold01 })}
`
